import { Button } from '@abtasty/design-system';
import { useState, useEffect } from 'react';
import styles from './errorfallback.module.scss';
import { useTranslation } from 'react-i18next';
import { FAQUrl } from '../../../../../constants';
import { Header } from '@src/application/modules/tag/Header/Header/Header';
import { DISABLED_COOKIES } from '../../../constants';

export function ErrorFallback({ error, resetError }) {
  const { t } = useTranslation();
  const [state, setState] = useState({
    url: FAQUrl,
    hasError: false,
    errorMessageTop: '',
    errorMessageBottom: '',
    error: '',
  });
  const cookiesDisabledFAQ = 'https://abtasty.zendesk.com/hc/en-us/articles/360018899099#h_01EWJQ8WJRGT7N954YQR843RJA';
  useEffect(() => {
    // 3rd party cookies disabled
    if (error.code === 18 || error.message === DISABLED_COOKIES) {
      return setState({
        ...state,
        url: cookiesDisabledFAQ,
        errorMessageTop: t(
          'We couldn’t open the QA Assistant probably due to the blocking of third party cookies on your browser.'
        ),
        errorMessageBottom: t('Please allow third party cookies on your website to continue.'),
      });
    }
    return setState({
      ...state,
      error: error.message,
      errorMessageTop: t('The following unexpected error occured:'),
      errorMessageBottom: t('Please take a screenshot of this page and console and send it to your dedicated CSM.'),
    });
  }, []);

  return (
    <>
      <Header />
      <div className={styles.container}>
        {/* TODO replace svg with svg from common-ui */}
        <svg className={styles.svg} xmlns="http://www.w3.org/2000/svg" width="15" height="40" viewBox="0 0 15 40">
          <defs>
            <filter id="9gdxpk9cha" width="107.8%" height="140.3%" x="-3.8%" y="-23.1%" filterUnits="objectBoundingBox">
              <feOffset dy="-5" in="SourceAlpha" result="shadowOffsetOuter1" />
              <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="8" />
              <feColorMatrix
                in="shadowBlurOuter1"
                result="shadowMatrixOuter1"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
              />
              <feMerge>
                <feMergeNode in="shadowMatrixOuter1" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
          </defs>
          <g fill="none" fillRule="evenodd">
            <g>
              <g filter="url(#9gdxpk9cha)" transform="translate(-712 -865) translate(0 788)">
                <g>
                  <path
                    fill="#3C1A15"
                    d="M2.5 25.001L5 25.001 5 12.501 2.5 12.501zM10 25.001L12.5 25.001 12.5 12.501 10 12.501zM0 12.501L2.5 12.501 2.5 2.501 0 2.501zM12.5 12.501L15.001 12.501 15.001 2.501 12.5 2.501zM5 27.501L10 27.501 10 25.001 5 25.001zM2.5 2.501L12.5 2.501 12.5 0 2.5 0zM5 32.501L10 32.501 10 30.001 5 30.001zM5 40.001L10 40.001 10 37.501 5 37.501zM2.5 37.501L5 37.501 5 32.501 2.5 32.501zM10 37.501L12.5 37.501 12.5 32.501 10 32.501z"
                    transform="translate(712 77)"
                  />
                  <path
                    fill="#CB3030"
                    d="M5 37.501L10 37.501 10 35.001 5 35.001zM5 25.001L10 25.001 10 22.501 5 22.501zM7.5 22.501L10 22.501 10 12.501 7.5 12.501z"
                    transform="translate(712 77)"
                  />
                  <path fill="#FF5252" d="M5 22.501L7.5 22.501 7.5 12.501 5 12.501z" transform="translate(712 77)" />
                  <path fill="#CB3030" d="M10 12.501L12.5 12.501 12.5 2.501 10 2.501z" transform="translate(712 77)" />
                  <path
                    fill="#FF5252"
                    d="M2.5 12.501L10 12.501 10 2.501 2.5 2.501zM7.5 35.001L10 35.001 10 32.501 7.5 32.501z"
                    transform="translate(712 77)"
                  />
                  <path
                    fill="#FF8282"
                    d="M5 35.001L7.5 35.001 7.5 32.501 5 32.501zM5 7.501L7.5 7.501 7.5 2.501 5 2.501zM2.5 12.501L5 12.501 5 7.501 2.5 7.501z"
                    transform="translate(712 77)"
                  />
                  <path fill="#F9B9B9" d="M2.5 7.501L5 7.501 5 2.501 2.5 2.501z" transform="translate(712 77)" />
                </g>
              </g>
            </g>
          </g>
        </svg>
        <div className={styles.paragraph}>
          {state.errorMessageTop}
          <br />
          {error && <p className={styles.error}>{error.toString()}</p>}
          {state.errorMessageBottom}
        </div>
        <div className={styles.buttons}>
          <a href={state.url} target="_blank" rel="noopener noreferrer">
            <Button
              size="small"
              className={styles.button}
              variant="outlined"
              label={t('Open QA Assistant troubleshooting')}
            />
          </a>
          <Button
            size="small"
            className={styles.button}
            label={t('Click here to reset')}
            onClick={resetError}
            icon="refresh"
          />
        </div>
      </div>
    </>
  );
}
